import React from 'react'
import { useMessageStore } from '@/stores/messageStore'
import MessageBox from '@/components/Message/MessageBox'

const InlineMessage = (): React.ReactElement | null => {
  const message = useMessageStore((s) => s.message)
  const clear = useMessageStore((s) => s.clear)

  if (!message || message.toast) return null

  return (
    <MessageBox
      message={message.text}
      type={(message.type ?? undefined) as 'error' | 'success' | 'warning' | 'info' | undefined}
      onClose={message.closable ? clear : undefined}
      closable={message.closable}
      icon={message.icon ?? undefined}
    />
  )
}

export default InlineMessage
